// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"96b81311","129":"d14c5d7e","150":"b60d7826","208":"7c994b15","255":"f68302d9","385":"b8604741","400":"ff82b632","463":"6f9b556d","623":"83feac25","637":"6648e563","725":"19798c54","728":"d75c6904","887":"d14c5d7e","920":"7c994b15"}[chunkId] + ".chunk.css";
};